/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model'
],
function(
    pip
){
	
	function initEventListeners(){
		
		$(document).on('click', '[data-target]', function(e){
			
			var target = $(this).data('target');
			var position;

			var component = $(e.target).closest('[data-component]');
			component =  $(component).data('component');

			var section = $(e.target).closest('[data-section]');
			section =  $(section).data('section');
			
			if($(this).data('has-index')){
				var listItems = $(this).closest('[data-component]').find('[data-has-index]');
				position = listItems.index(this) + 1;
			}
			
			subContentEvent(section, component, target, position);
			
		});
			
	}

	
	function subContentEvent(section, component, target, position){

		if(!section || !component || !target) return;

		var obj = {
	        category:{
	        	primaryCategory: 'interaction'
	        },
	        eventInfo:{
	        	eventName: 'pip sub-content'
	        },
        	subContent: {
        		section: section.toLowerCase(),
        		component: component.toLowerCase(),
        		target: target.toLowerCase(),
        		position: position || null
        	}
		};
		
		if (pip.debugMode) console.log(obj);
		
		if(window.digitalData && window.digitalData.event) window.digitalData.event.push(obj);
	}
	
	
	function getSubContentTree(){
		
		var obj = {};
		var sections = $('[data-section]').map(function(){ return $(this).data('section') }).toArray();
		
		for(var section in sections){
			if (sections.hasOwnProperty(section)){
				obj[sections[section]] = {};
			}
		}
		
		$.each(sections, function(i,section){
			
			var components = $('[data-section="'+ section +'"] [data-component]').map(function(){ 
				return $(this).data('component');
				}).toArray();
			
			for(var component in components){
				if (components.hasOwnProperty(component)){
					obj[section][components[component]] = [];
				}
			}
			
			$.each(components, function(i, component){
				
				var targets = $('[data-section="'+ section +'"] [data-component="' + component + '"]').find('[data-target]').map(function(){ 
					return $(this).data('target');
					}).toArray();
				
				for(var target in targets){
					if (targets.hasOwnProperty(target)){
						obj[section][component].push(targets[target])
					}
				}
				
			});
			
		});
		
		
		console.log(obj);
		return obj;
	}
	
	

	return {
		init: function(){
			initEventListeners();
		},
		getSubContentTree: getSubContentTree
	};

});
}.call(window));